@if (allowLoad$ | async) {
  <div
    class="list-container"
    [class.list-container--no-animations]="disableAnimations()"
  >
    <ul
      class="entity-list"
      pluginsList
      [pluginsListWrap]="true"
      [pluginsListRefocus]="false"
      #list="pluginsList"
    >
      @for (id of pickedEntitiesService.pickedIds$ | async; track id) {
        <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
        <li
          [attr.role]="profileLinksEnabled() ? 'link' : 'listitem'"
          class="entity-list__item"
          (click)="itemClick($event, id, $index)"
          (keydown)="itemKeydown($event, id, $index)"
          [pluginsAnimation]="ListItemAnimations"
          [pluginsAnimationDisabled]="isInitial()"
          pluginsListItem
          (pluginsListOnSelect)="itemSelected(id, $index)"
        >
          <plugins-user-entity
            [ngStyle]="{ height: listItemHeight() }"
            [userProvider]="
              (pickedEntitiesService.pickedEntities$ | async)?.get(id)
            "
            [profileLinkEnabled]="false"
            [showTitle]="true"
            [detailedTitle]="detailedTitle()"
            [size]="size()"
          />
        </li>
      }
    </ul>

    @if (showLoadButton$ | async) {
      <div
        class="load-more-button"
        [pluginsAnimation]="loadMoreAnimations"
        [pluginsAnimationDisabled]="isInitial() || !!(showLoadButton$ | async)"
      >
        @let config = buttonConfig();
        <plugins-shared-button
          [disabled]="disabled()"
          [aria]="config?.aria"
          [color]="config?.color"
          [size]="config?.size"
          [config]="config?.config"
          [variant]="config?.variant"
          [round]="config?.round"
          [className]="config?.class ?? 'primary'"
          [buttonStyle]="config?.style"
          [buttonId]="config?.id"
          (clicked)="loadMore()"
          >{{
            label()?.length ? label() : (defaultLabelText | translate)
          }}</plugins-shared-button
        >
      </div>
    }
    <div class="projected">
      <ng-content />
    </div>
  </div>
}
